<template>
<div class="fulldashboard">
  <div v-if="alertIsShowen" class="editProductContainer">
          <component v-if="alertIsShowen" v-bind:is="componentalert" 
                :alertText='"Wollen Sie das Produkt wirklich Löschen?"'
                :optionOne='"Ja"'
                :optionTwo='"Nein"'
                @oneTapped="deleteItem()"
                @twoTapped="alertIsShowen=false"
              >
          </component>
     
  </div>
  <div v-if="!isHidden" class="editProductContainer">
          
          <component v-if="!isHidden" v-bind:is="component" 
                    :brand='form.brand'
                    :ean='form.ean'
                    :designation='form.designation'
                    :description='form.description'
                    :productSize='form.productSize'
                    :nutrition='form.nutrition'
                    :ingredients='form.ingredients'
                    :keywords='form.keywords'
                    :image='imageUrl'
                    :maincategory ='form.maincategory'
                    :subcategory ='form.subcategory'
                    :isEdit ='isEdit'
                    >
          </component>
  </div>
  <div  style="margin-top: 50px;">
    <button v-if="!isHidden" class="stopEditButton" v-on:click="component=null, isHidden=true, reloadData()" >X</button>
        <div class="containerMyProducts">
            <router-link to="/articleupload">
                    <img
                     src="https://firebasestorage.googleapis.com/v0/b/baoopilotapp.appspot.com/o/baooLogos%2FaddProduct%402x.png?alt=media&token=f49b8040-9f77-48f2-b263-2feb20ea00ab"
                     class="image"
                   >
            </router-link>
          
            <div class="listStyle">
              <ArticleListItemWithPreview
                v-for="(item, index) in retailerItems"
                :key="item.id"
                :item="item"
                :brand="item.brand"
                :designation="item.designation"
                :image-u-r-l="item.imageUrl"
                @delet="showAlertBeforeDelet(item.id, index)"
                @edit="editProduct(item.id, item)"
              />
            </div>
          <notifications
            class="dashboardAlert"
            group="list-notifications"
            position="center bottom"
          />
      </div>
  </div>‚
  </div>
</template>

<script>
  import ArticleListItemWithPreview from "./ArticleListItemWithPreview";
  import ArticleUpload from "./ArticleUpload"
  import firebase from "firebase";
  // eslint-disable-next-line no-unused-vars
  import pEachSeries from 'p-each-series'
  import Alert from './Alert'

  export default {
    name: "ManufacturerArticleOverview",
    components: {
      ArticleListItemWithPreview,
      'articelUpload': ArticleUpload,
      'alert' : Alert
    },
    data() {
      return {
        retailerItems: [],
        isHidden: true,
        alertIsShowen: false,
        component: 'articelUpload',
        componentalert: 'alert',
               form: {
                  ean: "",
                  brand: "",
                  designation: "",
                  description: "",
                  productSize: "",
                  nutrition: "",
                  ingredients: "",
                  keywords: "",
                  maincategory:"",
                  subcategory:"",
                  imageUrl: ""
            },
            isEdit: true,
            imageUrl: "image",
            eanForDelet: "",
            indexForDelet: ""
      }
    },
    created () {
      // fetch the data
      this.fetchData();
    },
    methods: {
      showAlertBeforeDelet(ean, index) {
        this.eanForDelet = ean
        this.indexForDelet = index 
        this.alertIsShowen = true
      },
      reloadData(){
          this.retailerItems = []
          this.fetchData()
      },
      async deleteItem() {
        this.alertIsShowen = false
        const vm = this;
        const userId = firebase.auth().currentUser.uid;
        try{
          await firebase.database().ref("manufacture/" + userId + "/products/" + vm.eanForDelet).remove();
          await firebase.database().ref("products/" + vm.eanForDelet).remove();
          vm.retailerItems.splice(vm.indexForDelet, 1);
          this.$notify({
            group: 'list-notifications',
            title: 'Erfolg!',
            text: `Artikel ${vm.eanForDelet} wurde gelöscht.`,
            type: 'success',
            duration: 5000,
          });
        } catch(e) {
          this.$notify({
            group: 'list-notifications',
            title: 'Fehler!',
            text: `Es gab einen Fehler: ${e.message}`,
            type: 'error',
            duration: 5000,
          });
        }
      },
      editProduct(ean, product) {
        const vm = this;
        this.component= 'articelUpload'
        this.isHidden = false 
        vm.form.ean = ean
        vm.form.brand = product.brand 
        vm.form.designation = product.designation
        vm.form.description = product.description
        vm.form.productSize = product.productSize
        vm.form.ingredients = product.ingredients
        vm.form.nutrition = product.nutrition
        vm.form.keywords = product.keywords
        vm.form.maincategory = product.maincategory
        vm.form.subcategory = product.subcategory
        vm.imageUrl = product.imageUrl
        
      },
      async fetchData() {
        const vm = this;
        const userId = firebase.auth().currentUser.uid;
        try {
          const productsRef = firebase.database().ref("manufacture/" + userId + "/products/");
          productsRef.once('value', function(snapshot) {
            snapshot.forEach(function(childSnapshot) {
              const productEAN = childSnapshot.key.toString()
              const productRef = firebase.database().ref("products/" + productEAN);
              productRef.once('value', async function(snapshot) {
                const productEntity = snapshot.val()
                vm.retailerItems.push({
                  id: productEAN,
                  brand: productEntity.brand,
                  designation: productEntity.designation,
                  imageUrl: productEntity.imageUrl,
                  description: productEntity.description,
                  productSize: productEntity.productSize,
                  nutrition: productEntity.nutrition,
                  ingredients: productEntity.ingredients,
                  keywords: productEntity.keywords,
                  maincategory: productEntity.maincategory,
                  subcategory: productEntity.subcategory,
                })
              });
            });
          });
        } catch (e) {
          this.$notify({
            group: 'list-notifications',
            title: 'Fehler!',
            text: `Es gab einen Fehler beim Abrufen der Artikel: ${e.message}`,
            type: 'error',
            duration: 5000,
          });
        }
      }
    }
  }
</script>

<style scoped>
.backgroundOpacityAlert{
      position: fixed;
      background: #2B2C2B;
      opacity: 0.9;
      border-radius: 10px;
      width: 100%;
      height: 100%;
      margin-top:-50px;
      
    }
.editProductContainer{
  width: 100%;
  height: 100%;
  position: fixed;
  top: 50;
  left: 0;
  z-index: 10;
}
.stopEditButton{
  width: 40px;
  height: 40px;
  margin-left: 65%;
  position: fixed;
  z-index: 10;
  border: 0px solid;
  background-color: #f88623;
  border-radius: 20px;
  color: white;
  
}

.image{
  object-fit: scale-down;
  width: 350px;
  height: 80px;
  padding: 5px;
}
.button{
  width: 350px;
  height: 100px;
  background-color: #ffffff;
  border: #ffffff;
}
.listStyle{
  background-color:#ffffff;
  display: block;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19);
}
.containerMyProducts{
  align-content: left;
  background-color: #ffffff;
  width: 100%;
}
.dashboardAlert{
  margin-left: 150px;
}
.deletProductAlert{
  
  display: table;
  margin: 0 auto;
  border-radius:10px;
  margin-top: 50px;
  width: 500px;
  height: 100px;;
  padding-left: 700px;
  position: fixed;
}
.alertView{
 
}



@media screen and (max-width: 1400px)
{
    .containerMyProducts{
  
      width: 780px;
    }
}
@media screen and (max-width: 1140px)
{
    .containerMyProducts{
  
      width: 520px;
    }
}




</style>